import AOS from "aos"
import "aos/dist/aos.css"
import parse from "html-react-parser"
import React, { memo, useEffect } from "react"
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/navigation"
import "swiper/css/thumbs"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper/modules"
import * as style from "../../../Common/new/SectionsTitle/sectionTitle.module.css"
import LinkButtonRed from "../../buttons/linkButtonRed/linkButtonRed"
import OptimizedImage from "../../ImageShow/OptimizedImage"
import Counter from "../../newComponents/counter/counter"
import Mark from "../../svg/new/Mark"
import * as styles from "./mainBanner.module.css"

const MainBanner = props => {
  const {
    homeBannerShowSection,
    homeBannerBackgroundImage,
    staticUrl,
    classNames,
    homeBannerShowCelebrationImage,
    homeBannerCelebrationImage,
    homeCounterList,
    homeCounterShowSection,
    sliderImagesList,
    homeBannerContent,
    homeBannerTitle,
    homeBannerButtonText,
    homeBannerButtonLink,
    homeBannerSubTitle,
  } = props

  const webpageImageShow = newImg => {
    const extension = newImg?.split(".")?.pop()?.toLowerCase()
    if (extension && ["png", "jpg", "jpeg"].includes(extension)) {
      return newImg.replace(/\.[^.]+$/, ".webp")
    } else {
      return newImg
    }
  }

  const widthData = typeof window !== "undefined" && window.innerWidth

  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  return (
    <>
      {homeBannerShowSection === "yes" && (
        <section
          className={`${styles.main_banner} ${classNames || ""} ${homeBannerShowCelebrationImage === "yes" && widthData > 1025
            ? styles.years_section
            : ""
            }`}
        >
          <Swiper
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={sliderImagesList ? true : false}
            modules={[Autoplay]}
          >
            {sliderImagesList ? (
              <>
                {sliderImagesList?.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div
                        className={`${styles.banner_bg}`}
                        style={{
                          backgroundImage: `url(${webpageImageShow(item?.bgImage?.mediaItemUrl) ??
                            staticUrl
                            })`,
                        }}
                      >
                        <div className="container">
                          <div className="row">
                            <div
                              className={styles.banner_wrap}
                              data-aos="fade-up"
                              data-aos-delay="50"
                            >
                              <div className={styles.banner_info}>
                                <div
                                  className={` ${styles.banner_wrap_heading} ${style.mix_heading_wrap}`}
                                >
                                  <div
                                    className={` ${styles.banner_mix_heading} ${style.mix_heading}`}
                                  >
                                    <div className={style.viewAllLink}>
                                      <span className={style.small_text_span}>
                                        <i>
                                          {" "}
                                          <Mark />{" "}
                                        </i>
                                        {item.homeBannerTitle}
                                      </span>
                                    </div>

                                    {item?.homeBannerSubTitle && parse(`${item.homeBannerSubTitle}`)}

                                    <p>{parse(`${item.bannerContent}`)}</p>
                                  </div>
                                </div>
                                {item.bannerBtnText && (
                                  <LinkButtonRed
                                    btnText={item.bannerBtnText}
                                    linkTo={item.bannerButtonLink.url}
                                    CustomBtnClass={styles.banner_btn}
                                  />
                                )}
                              </div>
                              {homeBannerShowCelebrationImage === "yes" &&
                                widthData > 1025 && (
                                  <div className={styles.imageBox}>
                                    <OptimizedImage
                                      imageData={
                                        homeBannerCelebrationImage.mediaItemUrl
                                          ? homeBannerCelebrationImage.mediaItemUrl
                                          : "/images/placeholder-image.jpg"
                                      }
                                      alt={homeBannerCelebrationImage.altText}
                                    />
                                  </div>
                                )}
                              <div className={styles.counter_banner_wrap}>
                                <Counter
                                  homeCounterList={homeCounterList}
                                  homeCounterShowSection={
                                    homeCounterShowSection
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                })}
              </>
            ) : (
              <SwiperSlide>
                <div
                  className={`${styles.banner_bg}`}
                  style={{
                    backgroundImage: `url(${webpageImageShow(
                      homeBannerBackgroundImage?.mediaItemUrl
                    ) ?? staticUrl
                      })`,
                  }}
                >
                  <div className="container">
                    <div className="row">
                      <div
                        className={styles.banner_wrap}
                        data-aos="fade-up"
                        data-aos-delay="50"
                      >
                        <div className={styles.banner_info}>
                          <div
                            className={` ${styles.banner_wrap_heading} ${style.mix_heading_wrap}`}
                          >
                            <div
                              className={` ${styles.banner_mix_heading} ${style.mix_heading}`}
                            >
                              <div className={style.viewAllLink}>
                                <span className={style.small_text_span}>
                                  <i>
                                    {" "}
                                    <Mark />{" "}
                                  </i>
                                  {parse(`${homeBannerTitle}`)}
                                </span>
                              </div>

                              {homeBannerSubTitle && <h1>{parse(`${homeBannerSubTitle}`)}</h1>}

                              {homeBannerContent && (
                                <p>{parse(`${homeBannerContent}`)}</p>
                              )}
                            </div>
                          </div>
                          <LinkButtonRed
                            btnText={homeBannerButtonText}
                            linkTo={homeBannerButtonLink?.url}
                            CustomBtnClass={styles.banner_btn}
                          />
                        </div>
                        {homeBannerShowCelebrationImage === "yes" &&
                          widthData > 1025 && (
                            <div className={styles.imageBox}>
                              <OptimizedImage
                                imageData={
                                  homeBannerCelebrationImage.mediaItemUrl
                                    ? homeBannerCelebrationImage.mediaItemUrl
                                    : "/images/placeholder-image.jpg"
                                }
                                alt={homeBannerCelebrationImage.altText}
                              />
                            </div>
                          )}
                        <div className={styles.counter_banner_wrap}>
                          <Counter
                            homeCounterList={homeCounterList}
                            homeCounterShowSection={homeCounterShowSection}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            )}
          </Swiper>
        </section>
      )}
    </>
  )
}

export default memo(MainBanner)
